<template>
  <div :class="$style.content" id="cards">
    <div :class="$style.top">
      <div :class="$style.title">Мероприятия</div>
      <div :class="$style.tabs">
        <div
          :class="[$style.tab, { [$style.active]: activeTab === tab.slug }]"
          v-for="tab in tabs"
          :key="tab.slug"
          @click="setActiveTab(tab.slug)"
        >
          {{ tab.text }}
        </div>
      </div>
    </div>
    <div :class="$style.days">
      <div :class="$style.day" v-for="day in days" :key="day.title">
        <div :class="$style.dayText">{{ day.date }}</div>
        <div :class="$style.cards">
          <div
            :class="$style.card"
            v-for="card in day.cards.filter(
              (i) => i.categorySlug === activeTab || activeTab === 'all'
            )"
            :key="card.title"
          >
            <div :class="[$style.image, { [$style.big]: !card.isLimited }]">
              <img :src="card.image" alt="" />
            </div>
            <div :class="$style.info">
              <div :class="$style.limit">
                <img src="/icons/common/user.svg" alt="" />
                <span>{{ card.limit }}</span>
              </div>
              <div :class="$style.date">
                <img src="/icons/common/calendar.svg" alt="" />
                <span>{{ card.date }}</span>
              </div>
              <div :class="$style.time">
                <img src="/icons/common/clock.svg" alt="" />
                <span>{{ card.time }}</span>
              </div>
            </div>
            <div :class="$style.title">{{ card.title }}</div>
            <div :class="$style.note">{{ card.place }}</div>
            <div :class="$style.note" v-if="card.isLimited">
              Количество мест ограничено!
            </div>
            <div :class="[$style.note, $style.green]" v-else>
              Свободное посещение!
            </div>
            <div :class="$style.text">{{ card.text }}</div>
            <div
              v-if="card.isLimited"
              :class="$style.button"
              @click="(isOpen = true), (cardTitle = card.title)"
            >
              Записаться
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <FormModal :isOpen="isOpen" @closeModal="closeModal" :title="cardTitle" />
</template>

<script>
import FormModal from "@/components/FormModal.vue";
export default {
  components: {
    FormModal,
  },
  data() {
    return {
      tabs: [
        {
          slug: "all",
          text: "Все мероприятия",
        },
        {
          slug: "master-classes",
          text: "Мастер-классы",
        },
        {
          slug: "lectures",
          text: "Лекции",
        },
        {
          slug: "seminars",
          text: "Семинары",
        },
        {
          slug: "excursions",
          text: "Экскурсии",
        },
        {
          slug: "competitions",
          text: "Турниры",
        },
      ],
      days: [
        {
          title: "Понедельник",
          date: "20.10",
          cards: [
            {
              category: "Турниры",
              categorySlug: "competitions",
              image: "/images/chess.png",
              isLimited: true,
              limit: "30",
              date: "20 октября",
              time: "13:20",
              place: "аудитория 2/402",
              title: "Шахматный турнир",
              text: "Приглашаем всех желающих поучаствовать в турнире по быстрым шахматам! От организаторов Международного шахматного Турнира «Черная пешка». Победителя ожидает ценный приз!  ",
            },
            {
              category: "Мастер-класс",
              categorySlug: "master-classes",
              image: "/images/master-classes.png",
              isLimited: true,
              limit: "20",
              date: "20 октября",
              time: "13:20",
              place: "аудитория 2/402",
              title:
                "Мастер-класс «Стратегии Древнего Китая» от носителей культуры",
              text: "Это ваш шанс не просто научиться играть, а понять философию и культурный контекст этих древних китайских игр из первых рук. ♟️ Сянци – китайские шахматы: динамичная и стратегическая битва на доске. Готовьтесь к молниеносным атакам!⚫️ Го (Вейци) – философия в камнях – игра с 4000-летней историей. Вы освоите базовые правила, поймете принципы захвата территории и почувствуете элегантную глубину этой игры, которая ценится мыслителями и стратегами во всем мире.",
            },
            {
              category: "Экскурсии",
              categorySlug: "excursions",
              image: "/images/excursions.png",
              isLimited: true,
              limit: "20",
              date: "20 октября",
              time: "17.00",
              title: "Экскурсия в офис ТБанк",
              text: "Узнайте, как работает IT-компания изнутри!",
            },
          ],
        },
        {
          title: "Вторник",
          date: "21.10",
          cards: [
            {
              category: "Лекции",
              categorySlug: "lectures",
              image: "/images/lectures.png",
              isLimited: false,
              limit: "50",
              date: "21 октября",
              time: "11:10",
              place: "аудитория 2/401А",
              title: "Митап от ТБанк «Мой первый пет-проект»",
              text: "Пет-проект (pet – англ. «питомец»)– это тренировочный проект, который специалист создаёт в свободное время и по собственному желанию, сам придумывает и воплощает идею. Это показатель творческого потенциала специалиста. ТБанк приглашает на митап всех, кто хочет узнать подробнее, как завести свой собственный пет-проект!",
            },
            {
              category: "Семинары",
              categorySlug: "seminars",
              image: "/images/seminars.png",
              isLimited: false,
              limit: "40",
              date: "21 октября",
              time: "13:00",
              place: "аудитория 5/300",
              title:
                "Научный семинар со студентами «Достижения студентов ФЭИС»",
              text: "Узнайте, какие проекты создают наши студенты в учебно-научно-практической лаборатории «Промышленная робототехника». Научный семинар – это уникальная возможность заглянуть в будущее технологий и пообщаться с талантливыми разработчиками! ",
            },
            {
              category: "Мастер-классы",
              categorySlug: "master-classes",
              image: "/images/master-classes.png",
              isLimited: false,
              limit: "100",
              date: "21 октября",
              time: "14:40",
              place: "аудитория 2/114",
              title:
                "Мастер-класс «Демо-проект АСУТП» с демонстрацией аппаратного и программного обеспечения",
              text: "Мастер-класс от лидера промышленности ОАО «Савушкин продукт» поможет связать академические знания с практическими задачами производства.",
            },
            {
              category: "Мастер-классы",
              categorySlug: "master-classes",
              image: "/images/master-classes.png",
              isLimited: true,
              limit: "15",
              date: "",
              time: "",
              place:
                "время и место проведения будут уточнены после регистрации",
              title:
                "Мастер-класс «Создание открыток с помощью промышленного робота» ",
              text: "Мастер-класс от учебно-научно-практической лаборатории «Промышленная робототехника». Студенты ФЭИС продемонстрируют возможности промышленного робота Inovance типа SCARA и обучат навыкам работы с ним.",
            },
            {
              category: "Мастер-классы",
              categorySlug: "master-classes",
              image: "/images/master-classes.png",
              isLimited: true,
              limit: "15",
              date: "",
              time: "",
              place:
                "время и место проведения будут уточнены после регистрации",
              title: "Мастер-класс «Робот-собака Unitree Go2» ",
              text: "Мастер-класс от учебно-научно-практической лаборатории «Промышленная робототехника». Студенты ФЭИС продемонстрируют возможности промышленного робота Inovance типа SCARA и обучат навыкам работы с ним.",
            },
            {
              category: "Мастер-классы",
              categorySlug: "master-classes",
              image: "/images/master-classes.png",
              isLimited: true,
              limit: "15",
              date: "",
              time: "",
              place:
                "время и место проведения будут уточнены после регистрации",
              title:
                "Мастер-класс «Распознавание объектов подводным аппаратом Middle AUV»",
              text: "Мастер-класс от учебно-научно-практической лаборатории «Промышленная робототехника». Студенты ФЭИС продемонстрируют возможности современного оборудования лаборатории и обучат навыкам работы с ним.",
            },
            {
              category: "Мастер-классы",
              categorySlug: "master-classes",
              image: "/images/master-classes.png",
              isLimited: true,
              limit: "15",
              date: "",
              time: "",
              place:
                "время и место проведения будут уточнены после регистрации",
              title: "Мастер-класс «Виртуальная выставка ФЭИС» ",
              text: "Мастер-класс от учебно-научно-практической лаборатории «Промышленная робототехника». Студенты ФЭИС продемонстрируют возможности современного оборудования лаборатории и проведут виртуальную экскурсию с помощью VR-очков.",
            },
            {
              category: "Мастер-классы",
              categorySlug: "master-classes",
              image: "/images/master-classes.png",
              isLimited: true,
              limit: "15",
              date: "",
              time: "",
              place:
                "время и место проведения будут уточнены после регистрации",
              title:
                "Мастер-класс «Игра на музыкальном инструменте с помощью коллаборативного робота» ",
              text: "Мастер-класс от учебно-научно-практической лаборатории «Промышленная робототехника». Студенты ФЭИС продемонстрируют возможности коллаборативного робота ТМ-12S и обучат навыкам работы с ним.",
            },
            {
              category: "Мастер-классы",
              categorySlug: "master-classes",
              image: "/images/master-classes.png",
              isLimited: true,
              limit: "15",
              date: "",
              time: "",
              place:
                "время и место проведения будут уточнены после регистрации",
              title:
                "Мастер-класс «Гравировка брелоков ФЭИС на лазерном гравирующем станке» ",
              text: "Мастер-класс от учебно-научно-практической лаборатории «Промышленная робототехника». Студенты ФЭИС продемонстрируют возможности лазерного гравирующего станка и обучат навыкам работы с ним. Есть шанс уйти с подарком! ",
            },
          ],
        },
        {
          title: "Среда",
          date: "22.10",
          cards: [
            {
              category: "Лекции",
              categorySlug: "lectures",
              image: "/images/lectures.png",
              isLimited: true,
              limit: "25",
              date: "22 октября",
              time: "11:10",
              place: "аудитория 2/215",
              title: "Митап от ЮКОЛА",
              text: "Не упусти шанс получить практические навыки от крупнейшего в Беларуси разработчика IT-решений на платформе «1C». ",
            },
            {
              category: "Лекции",
              categorySlug: "lectures",
              image: "/images/lectures.png",
              isLimited: true,
              limit: "25",
              date: "22 октября",
              time: "13:10",
              place: "аудитория 2/215",
              title: "Митап от Success",
              text: "Открой для себя новое направление в IT – Salesforce! Даже базовое знакомство поможет выделиться среди других кандидатов.",
            },
            {
              category: "Семинары",
              categorySlug: "seminars",
              image: "/images/seminars.png",
              isLimited: true,
              limit: "15",
              date: "22 октября",
              time: "14.00-16.00",
              place: "аудитория 5/300",
              title:
                "Семинар с организациями-партнерами «Перспективные направления интеграции науки, производства и образования»",
              text: "Получите уникальный шанс пообщаться с топ-специалистами индустрии! Приглашаем самых активных и талантливых студентов ФЭИС!",
            },
            {
              category: "Лекции",
              categorySlug: "lectures",
              image: "/images/lectures.png",
              isLimited: false,
              limit: "100",
              date: "22 октября",
              time: "14.40",
              place: "аудитория 2/114",
              title: "Воркшоп по алгоритмам от ТБанк",
              text: "Алгоритмы – основа IT! На воркшопе вы познакомитесь с основными алгоритмами и структурами данных – эти знания помогут при прохождении отборов на программы и стажировки в IT-компаниях.",
            },
            {
              category: "Экскурсии",
              categorySlug: "excursions",
              image: "/images/excursions.png",
              isLimited: false,
              limit: "25",
              date: "22 октября",
              time: "16.30",
              place: "только для студентов группы АС-70",
              title: "Экскурсия в офис ЮКОЛА-ИНФО-Брест",
              text: "Узнайте, как работает IT-компания изнутри!",
            },
          ],
        },
        {
          title: "Четверг",
          date: "23.10",
          cards: [
            {
              category: "Турниры",
              categorySlug: "competitions",
              image: "/images/hakaton.png",
              isLimited: true,
              limit: "30",
              date: "23-24.10.2025 ",
              time: "8.00-19.00",
              place: "аудитории 2/310 (2/306)",
              title: "Хакатон «FEIS Tech»",
              text: "Получите навыки создания инновационных решений по задачам и при экспертной менторской поддержке от IT-компаний! Приглашаем самых активных и талантливых студентов ФЭИС! Если у вас еще нет команды – регистрируйтесь индивидуально. Кроме памятных призов, команду-победителя хакатона ждет награждение именными сертификатами на зачет или экзамен по специальной дисциплине …",
            },
            {
              category: "Экскурсия",
              categorySlug: "excursions",
              image: "/images/excursions.png",
              isLimited: false,
              limit: "50",
              date: "23-24.10.2025 ",
              time: "8.00-19.00",
              place: "только для студентов групп МС-11 и Э64",
              title: "Экскурсия в Брестский научно-технологический парк",
              text: "Узнайте, как работает крупнейший инновационный центр и главный инкубатор малого предпринимательства.",
            },
          ],
        },
        {
          title: "Пятница",
          date: "24.10",
          cards: [
            {
              category: "",
              categorySlug: "all",
              image: "/images/concert.png",
              isLimited: false,
              limit: "",
              date: "24 октября",
              time: "14.00",
              title: "Праздничный концерт",
              text: "с награждением победителей",
            },
          ],
        },
      ],
      activeTab: "all",
      cardTitle: "",
      isOpen: false,
    };
  },
  methods: {
    setActiveTab(slug) {
      this.activeTab === slug
        ? (this.activeTab = "all")
        : (this.activeTab = slug);
    },
    closeModal(value) {
      this.isOpen = value;
    },
  },
};
</script>

<style lang="scss" module>
.content {
  background-color: $white;
  padding: 1rem;
  border-radius: 1.5rem;
}
.top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin: 0 0 2rem 0;
  @include custom(1100) {
    display: block;
  }
  .title {
    font-weight: 700;
    font-size: 1.875rem;
    @include custom(1100) {
      margin: 0 0 1rem 0;
    }
  }
  .tabs {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    @include custom(1100) {
      justify-content: flex-start;
    }
    @include custom(975) {
      overflow: auto;
      @include scrollbarX;
      padding: 0 0 0.5rem 0;
    }
    .tab {
      padding: 0.5rem 1rem;
      font-weight: 600;
      font-size: 1.125rem;
      border-radius: 1.5rem;
      background-color: $grey;
      transition: all 0.3s ease-in-out;
      cursor: pointer;
      &.active {
        background-color: $main;
        color: $white;
      }
      @include custom(800) {
        font-size: 1rem;
      }
      @include custom(975) {
        white-space: nowrap;
      }
    }
  }
}
.days {
  .day {
    position: relative;
    left: 2.2rem;
    border-left: 2px dashed $main;
    padding-top: 4rem;
    &:first-child {
      padding-top: 0;
      .dayText {
        top: 0;
      }
    }
    @include custom(540) {
      left: 1rem;
    }
    .dayText {
      position: absolute;
      top: 4rem;
      left: -2.15rem;
      background-color: $main;
      padding: 0.75rem;
      border-radius: 6.25rem;
      color: $white;
      @include custom(540) {
        left: -1.6rem;
        padding: 0.5rem;
        font-size: 0.8rem;
      }
    }
    .cards {
      padding: 0 4rem;
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 1.5rem;
      @include custom(900) {
        grid-template-columns: 1fr;
      }
      @include custom(540) {
        padding: 0 2rem;
      }
      .card {
        display: flex;
        flex-direction: column;
        position: relative;
        background-color: $grey;
        border-radius: 1.5rem;
        padding: 1.5rem;
        @include custom(540) {
          padding: 1rem;
        }
        .image {
          margin: 0 0 1rem 0;
          img {
            height: 14rem;
            width: 100%;
            object-fit: cover;
            border-radius: 1.5rem;
            @include custom(1030) {
              height: 12rem;
            }
            @include custom(900) {
              height: 14rem;
            }
            @include custom(590) {
              height: 12rem;
            }
            @include custom(460) {
              height: 10rem;
            }
            @include custom(390) {
              height: 8rem;
            }
          }
          &.big {
            img {
              height: 16rem;
              @include custom(1150) {
                height: 14rem;
              }
              @include custom(1030) {
                height: 12rem;
              }
              @include custom(900) {
                height: 14rem;
              }
              @include custom(590) {
                height: 12rem;
              }
              @include custom(460) {
                height: 10rem;
              }
              @include custom(390) {
                height: 8rem;
              }
            }
          }
        }
        .info {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          margin: 0 0 1rem 0;
          .limit {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            color: $white;
            background-color: $main;
            padding: 1rem;
            border-radius: 1.5rem;
            @include custom(1020) {
              font-size: 0.8rem;
              padding: 0.5rem;
            }
            @include custom(900) {
              padding: 1rem;
              font-size: 1rem;
            }
            @include custom(600) {
              font-size: 0.8rem;
              padding: 0.5rem;
            }
            @include custom(460) {
              font-size: 0.65rem;
            }
          }
          .date {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            background-color: $white;
            padding: 1rem;
            border-radius: 1.5rem;
            @include custom(1020) {
              font-size: 0.8rem;
              padding: 0.5rem;
            }
            @include custom(900) {
              padding: 1rem;
              font-size: 1rem;
            }
            @include custom(600) {
              font-size: 0.8rem;
              padding: 0.5rem;
            }
            @include custom(460) {
              font-size: 0.65rem;
            }
          }
          .time {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            background-color: $white;
            padding: 1rem;
            border-radius: 1.5rem;
            @include custom(1020) {
              font-size: 0.8rem;
              padding: 0.5rem;
            }
            @include custom(900) {
              padding: 1rem;
              font-size: 1rem;
            }
            @include custom(600) {
              font-size: 0.8rem;
              padding: 0.5rem;
            }
            @include custom(460) {
              font-size: 0.65rem;
            }
          }
        }
        .title {
          font-weight: 600;
          font-size: 1.5rem;
          margin: 0 0 1rem 0;
          @include custom(1100) {
            font-size: 1.2rem;
          }
        }
        .note {
          font-weight: 500;
          color: $red;
          margin: 0 0 1rem 0;
          &.green {
            color: $main;
          }
        }
        .text {
          font-weight: 500;
          color: #11111166;
          margin: 0 0 1rem 0;
          flex: 1 1 auto;
        }
        .button {
          color: $white;
          background-color: $main;
          text-align: center;
          cursor: pointer;
          padding: 1.125rem;
          border-radius: 1.5rem;
        }
      }
    }
  }
}
</style>
